// src/components/HistoryListHeader/HistoryListHeader.jsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import './HistoryListHeader.css';
import { IconButton, Tooltip, Button } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';

const HistoryListHeader = ({ onOpenFilters, onClearFilters, areFiltersApplied }) => {
    const { t } = useTranslation();

    return (
        <div className="history-list-header-container">
            <div className="actions-row">
                <Tooltip title={t('historyListHeader.actions.showFilters')} arrow>
                    <IconButton
                        className="filter-icon-btn"
                        onClick={onOpenFilters}
                        aria-label={t('historyListHeader.actions.showFilters')}
                    >
                        <FilterAltIcon />
                    </IconButton>
                </Tooltip>

                {areFiltersApplied && (
                    <Tooltip title={t('historyListHeader.actions.clearFiltersTooltip')} arrow>
                        <Button
                            className="clear-filters-link-btn effect-underline"
                            onClick={onClearFilters}
                            variant="text"
                            endIcon={<FilterAltOffIcon />}
                        >
                            {t('historyListHeader.actions.clearFiltersButton')}
                        </Button>
                    </Tooltip>
                )}
            </div>

            <div className="titles-row">
                <span className="title-content-details">{t('historyListHeader.titles.contentDetails')}</span>
                <span className="title-analysis-result">{t('historyListHeader.titles.analysisResult')}</span>
            </div>
        </div>
    );
};

export default HistoryListHeader;